import { useState, ReactNode } from 'react';
import { FontSize, FontSizeContext } from '@/contexts/fontSizeContextValue';

export function FontSizeProvider({ children }: { children: ReactNode }) {
  const [fontSize, setFontSize] = useState<FontSize>('small');

  const getFontSizeClass = () => {
    switch (fontSize) {
      case 'small':
        return 'text-xs'; // Current manager view font size
      case 'medium':
        return 'text-sm'; // Between analyst and manager
      case 'large':
        return 'text-base'; // Analyst font size
      default:
        return 'text-xs';
    }
  };

  const getDashboardFontSizeClass = () => {
    // This class will be applied to dashboard content only, not navigation bars
    return `dashboard-content-${fontSize}`;
  };

  return (
    <FontSizeContext.Provider value={{ fontSize, setFontSize, getFontSizeClass, getDashboardFontSizeClass }}>
      {children}
    </FontSizeContext.Provider>
  );
}
